import {
  OrderPayload,
  Workout,
} from "src/modules/fithub-shared/interfaces/workout";
import api from "src/rest/api";

export async function copy(id: string, protocol?: string) {
  try {
    const res = await api.post<Workout>("/workouts/import", {
      id,
      protocol,
    });

    Promise.resolve(res.data.id);
  } catch (err) {
    Promise.reject(err);
  }
}

export async function reorder(workouts: Workout[]): Promise<OrderPayload> {
  return new Promise((resolve, reject) => {
    try {
      const order: OrderPayload = workouts.map(({ id, order }) => ({
        id,
        order,
      }));

      api
        .post<OrderPayload>("/workouts/update-order", {
          order,
        })
        .then((res) => resolve(res.data));
    } catch (error) {
      reject(error);
    }
  });
}

export async function createTemplate(id: string) {
  if (!id) return;
  try {
    api.post("/workouts/create-template", {
      id: id,
    });
    Promise.resolve();
  } catch {
    Promise.reject();
  }
}
